export default __webpack_public_path__ + "static/media/FAQ SGU VIRTUAL TOUR .a4df4304.pdf";